import request from '@/utils/request';

// 从环境变量中获取API基础URL，如果不存在则使用默认值
// const API_URL = process.env.VUE_APP_API_BASE_URL || 'https://ddrl.xyz/api';

class AIService {
  /**
   * 获取随机题目
   * @returns {Promise} 随机题目响应
   */
  getRandomProblem() {
    return request.get(`/api/ai/api/random-problem`);
  }
  
  /**
   * 上传音频或文本
   * @param {FormData} formData - 包含音频或文本的表单数据
   * @param {string} model - AI模型名称
   * @returns {Promise} 上传响应
   */
  uploadAudio(formData, model = 'deepseek-r1') {
    // 确保model参数被添加到formData中
    if (model && !formData.has('model')) {
      formData.append('model', model);
    }
    
    return request.post(`/api/ai/api/upload_audio`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  }
  
  /**
   * 获取文本状态
   * @param {string} path - 文本路径
   * @returns {Promise} 文本状态响应
   */
  getTextStatus(path) {
    return request.get(`/api/ai/api/get_text_status`, { path });
  }
  
  /**
   * 获取分析文件
   * @param {string} path - 文件路径
   * @param {boolean} forceRefresh - 是否强制刷新
   * @returns {Promise} 分析文件响应
   */
  getAnalysisFile(path, forceRefresh = false) {
    const params = { path };
    if (forceRefresh) {
      params._nocache = Date.now();
    }
    return request.get(`/api/ai/api/get_analysis_file`, params);
  }
  
  /**
   * 发送追问
   * @param {string} message - 追问消息
   * @param {string} model - AI模型名称
   * @returns {Promise} 追问响应
   */
  sendFollowUp(message, model = 'deepseek-v3') {
    return request.post(`/api/ai/api/send_follow_up`, { message, model });
  }
  
  /**
   * 提交自定义题目
   * @param {Object} data - 题目数据
   * @returns {Promise} 提交响应
   */
  submitCustomProblem(data) {
    return request.post(`/api/ai/api/custom_problem`, data);
  }
}

export default new AIService();
